import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { usePayment } from "../../../../APIContext/PaymentContext";
import Swal from "sweetalert2";
import PageTitle from "../../../../Components/Layout/UserDashLyout/PageTitle";
import "./style.css";

const AddNewCard = () => {
  const { createSetupIntent, syncCard, loading } = usePayment();
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);

  const handleAddCard = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setProcessing(true);

    const clientSecret = await createSetupIntent();
    // console.log("Client Secret:", clientSecret);
    if (!clientSecret) {
      setProcessing(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    if (error) {
      console.error("Stripe error:", error.message);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: error.message,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setProcessing(false);
      return;
    }

    // console.log("SetupIntent:", setupIntent);

    const res = await syncCard(setupIntent.payment_method);
    if (res) {
      Swal.fire({
        icon: "success",
        title: "Card Saved",
        text: "Your card has been added successfully!",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    setProcessing(false);
  };

  return (
    <>
      <PageTitle
        title="Add New Card"
        showButton={false}
        showDescription={false}
      />
      <div className="addcard-container">
        <form className="addcard-form" onSubmit={handleAddCard}>
          <h4 className="addcard-title black-text-clip">Add a New Payment Card</h4>

          <div className="addcard-group">
            <label className="addcard-label black-text-clip">Card Details</label>
            <div className="addcard-card-element">
              <CardElement options={{ style: { base: { fontSize: "16px" } } }} />
            </div>
          </div>

          <div className="addcard-btn-group">
            <button className="addcard-btn addcard-btn-orange" disabled={processing || loading}>
              {processing ? "Saving..." : "Save Card"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddNewCard;
